import {
    createBpmPropertiesDs,
    getConnection,
    getCurSession
} from '../_shared/GWTBridge/invoke/bpm/bpmMain';
import {buildServerCall} from './wcfService';
import {
    BpmBoolProps,
    BpmEname,
    BpmStatProps,
    BpmStatus
} from '../_shared/GWTBridge/invoke/bpm/types';

export const bpmInsertStatus = (statusTitle: string) => {
    const methodName = 'BPMInsertStatus';
    const reason = 'BPMInsertStatus';
    const parameters = {session: [getCurSession()], title: [statusTitle]};

    return buildServerCall(methodName, parameters, reason, true, getConnection);
};

export const bpmPropsAsync = (
    status: BpmStatus,
    eName: BpmEname | null,
    boolProps: Array<BpmBoolProps>,
    statProps: Array<BpmStatProps>
) => {
    const propertiesDsXml = createBpmPropertiesDs(status, eName, boolProps, statProps);
    const methodName = 'BPMProps';
    const reason = 'BPMProps';
    const parameters = {xml: [propertiesDsXml]};
    return buildServerCall(methodName, parameters, reason, true, getConnection);
};
